import { css, media, tokens, ButtonConfig, CompositeFieldConfig, PhoneNumberFieldConfig, SearchFieldConfig } from '@sail/ui';
export const phoneNumberFieldCustomization = PhoneNumberFieldConfig.customize({
    variants: {
        size: {
            small: {
                subviews: {
                    countryInput: {
                        css: {
                            paddingBlock: '0',
                            paddingY: 'xsmall',
                            paddingLeft: 'space.150'
                        }
                    }
                }
            },
            medium: {
                subviews: {
                    countryInput: {
                        css: {
                            paddingY: 'xsmall',
                            paddingLeft: 'xsmall'
                        }
                    },
                    phoneNumberInput: {
                        css: {
                            height: '28px'
                        }
                    }
                }
            },
            large: {
                subviews: {
                    countryInput: {
                        css: {
                            paddingY: 'small',
                            paddingLeft: 'xsmall'
                        }
                    },
                    phoneNumberInput: {
                        css: {
                            height: '36px'
                        }
                    }
                }
            }
        }
    },
    uses: [
        css({
            display: 'flex',
            gapX: 'large',
            gapY: 'small',
            [media.up(tokens.viewport.small)]: {
                display: 'grid',
                gapY: '0',
                gridTemplateColumns: '1fr 2fr',
                gridTemplateRows: 'repeat(auto-fit)'
            }
        }),
        CompositeFieldConfig.customize({
            subviews: {
                inputs: {
                    css: {
                        width: '100%'
                    }
                }
            }
        }),
        SearchFieldConfig.customize({
            css: {
                padding: `${tokens.space.xsmall} ${tokens.space.small}`
            },
            subviews: {
                textfield: {
                    css: {
                        display: 'flex'
                    }
                }
            }
        }),
        ButtonConfig.customize({
            css: {
                padding: '0',
                height: '28px'
            }
        })
    ],
    subviews: {
        countryInput: {
            css: {
                padding: 0,
                fontWeight: '400',
                textColor: 'text',
                display: 'flex'
            }
        },
        phoneNumberInput: {
            uses: [
                css({
                    display: 'flex',
                    alignItems: 'center'
                })
            ]
        },
        countryCallingCode: {
            uses: [
                css({
                    marginLeft: '-8px'
                })
            ]
        }
    },
    defaults: {
        className: 'helmPhoneNumberField'
    }
});

//# sourceMappingURL=phoneNumberField.js.map